import type { CityConfig } from "../city-template/types";

export const ciceroConfig: CityConfig = {
  city: "Cicero",
  state: "Illinois",
  stateAbbr: "IL",
  slug: "cicero",
  route: "/cicero",
  title: "Emergency Passport Cicero, IL — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Cicero, Illinois — as fast as 24 hours. Fast passport renewal and new passport applications for Cicero, Berwyn, Stickney, and all western Cook County residents. A+ BBB rated registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Cicero, IL",
  heroSubtitle: "Western Cook County family trip to Mexico with two weeks notice? Cicero business trip to Guadalajara and your passport is expired? Berwyn resident heading to Europe for summer vacation? We help Cicero and western Cook County residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Cicero%20Illinois%20urban%20neighborhood%20with%20tree-lined%20residential%20streets%2C%20historic%20brick%20bungalows%2C%20CTA%20Pink%20Line%20train%20tracks%2C%20Hawthorne%20Race%20Course%20horse%20racing%20facility%2C%20Morton%20College%20campus%2C%20vibrant%20commercial%20district%20along%20Cermak%20Road%2C%20warm%20afternoon%20golden%20light%2C%20community-focused%20Chicago%20suburb%20professional%20photography&width=1800&height=700&seq=cicero-hero-001&orientation=landscape",
  heroImageAlt: "Cicero Illinois urban neighborhood with historic architecture and Cermak Road commercial district",
  geoPosition: "41.8445;-87.7593",
  geoPlacename: "Cicero, Illinois",
  lastModified: "2026-06-04",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 25 minutes east of Cicero via I-290 or Cermak Road",
  },
  nearbyCitiesZips: [
    { name: "Cicero", zips: "60804" },
    { name: "Berwyn", zips: "60402" },
    { name: "Stickney", zips: "60402" },
    { name: "Lyons", zips: "60534" },
    { name: "Oak Park", zips: "60301, 60302, 60304" },
    { name: "Forest Park", zips: "60130" },
    { name: "North Riverside", zips: "60546" },
    { name: "Brookfield", zips: "60513" },
    { name: "Riverside", zips: "60546" },
    { name: "Summit", zips: "60501" },
    { name: "Bedford Park", zips: "60499" },
    { name: "Bridgeview", zips: "60455" },
    { name: "Burbank", zips: "60459" },
    { name: "Oak Lawn", zips: "60453" },
    { name: "La Grange", zips: "60525" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago Passport Agency — just 25 minutes east via I-290" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-plane-line", title: "Midway Airport Hub", desc: "Chicago Midway is right next door — we help Cicero travelers catch international connections" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no downtown Chicago trip required" },
  ],
  internalLinks: [
    { name: "Expedited passport in Oak Park, IL", route: "/oak-park" },
    { name: "Emergency passport help in Chicago, IL", route: "/chicago" },
    { name: "Urgent passport services in Berwyn, IL", route: "/illinois" },
    { name: "Illinois passport services overview", route: "/illinois" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Cicero, Illinois remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (25 minutes east via I-290 or Cermak Road) — without you making the trip. Cicero residents can ship from any UPS or FedEx in western Cook County.",
  fpcOfficeDistance: "Serving Cicero, Berwyn, Stickney, Lyons, Oak Park, Forest Park, North Riverside, Brookfield, Riverside, Summit, and all of western Cook County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Cicero and western Cook County. From the neighborhoods along Cermak Road and the bungalow-lined streets of central Cicero to the Morton College campus, from the Berwyn Depot district to the suburban communities of Stickney and Lyons — we serve all of the near western suburbs.",
  nearbyCitiesIntro: "We serve Cicero and all nearby communities including Berwyn, Stickney, Lyons, Oak Park, Forest Park, North Riverside, Brookfield, Riverside, Summit, Bedford Park, Bridgeview, Burbank, Oak Lawn, and La Grange. We also serve all of western Cook County.",
  howItWorksIntro: "Most Cicero travelers complete everything online and ship documents overnight. No need to drive 25 minutes to downtown Chicago — our couriers handle the Chicago Passport Agency trip for you.",
  mistakesIntro: "Cicero is one of Cook County's largest municipalities with deep international family roots and easy access to two major airports. Here are the most common passport mistakes we see from Cicero and western Cook County travelers.",
  testimonialsIntro: "Cicero and western Cook County travelers — from long-time families to Midway Airport business commuters to Morton College students — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Cicero, IL? Here are the most common ones we hear from western Cook County travelers.",
  statePageRoute: "/states/illinois",
  statePageName: "Illinois",
  dmvWebsite: "https://www.ilsos.gov/facilities/facilitylist.html",
  dmvLabel: "Illinois Secretary of State — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "No drive to downtown Chicago required", "Perfect for family travel to Mexico and Latin America", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 25 minutes to downtown Chicago", "Downtown Chicago parking and navigation"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Cicero travelers with immediate departure needs — as fast as 24 hours. Our couriers use the Chicago Passport Agency — 25 minutes away but you never make the trip.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency direct courier", "Midway Airport international connection support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Cicero adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Cicero address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Cicero residents — including large family groups, new citizens, and young travelers.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Cicero residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Cicero families with kids traveling to visit family abroad.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Cicero and Cook County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Cicero IL", description: "Urgent passport processing for Cicero Illinois travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Cicero IL", description: "Fast passport renewal for Cicero Illinois residents with a previously-issued passport." },
    { name: "First-Time Passport Cicero IL", description: "New passport application services for Cicero Illinois residents applying for their first passport." },
    { name: "Child Passport Cicero IL", description: "Minor passport services for Cicero Illinois families with children under 16." },
  ],
  testimonials: [
    {
      name: "Maria Elena R.",
      location: "Cicero, IL",
      rating: 5,
      text: "Family wedding in Mexico City and I realized my passport was expired with 7 days to go. Fast Passport Center had my renewal in 34 hours. Shipped from the UPS on Cermak Road. My whole family uses them now for all international trips.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Carlos H.",
      location: "Berwyn, IL",
      rating: 5,
      text: "My son needed his first passport for a school trip to Spain. Fast Passport Center walked us through the whole thing — child passport, DS-11, both parents consent. Got it in 4 days. Amazing service for western Cook County families.",
      service: "Child Passport",
    },
    {
      name: "Ana G.",
      location: "Cicero, IL",
      rating: 5,
      text: "Lost my passport at Midway Airport two days before a family trip to Guatemala. Fast Passport Center got me a replacement in under 48 hours. I used the FedEx on Harlem Avenue. Saving the trip felt like a miracle!",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "cic-1",
      name: "Cicero Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2440 S Laramie Ave",
      city: "Cicero",
      state: "IL",
      zip: "60804",
      phone: "(708) 656-1711",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Cicero, near Laramie Avenue",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Cicero acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to CTA Pink Line and Cermak Road corridor.",
      icon: "ri-mail-line",
    },
    {
      id: "cic-2",
      name: "Berwyn Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6625 Cermak Rd",
      city: "Berwyn",
      state: "IL",
      zip: "60402",
      phone: "(708) 788-0041",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Berwyn, approximately 2 miles west of Cicero",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Berwyn, Stickney, and western Cicero residents. Near Berwyn Depot District.",
      icon: "ri-mail-line",
    },
    {
      id: "cic-3",
      name: "Oak Park Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "901 Lake St",
      city: "Oak Park",
      state: "IL",
      zip: "60301",
      phone: "(708) 848-5192",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Oak Park, approximately 4 miles northwest of Cicero",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Full passport acceptance. Good alternative for northern Cicero residents. Near CTA Green Line.",
      icon: "ri-mail-line",
    },
    {
      id: "cic-4",
      name: "Cook County Clerk — Bridgeview",
      type: "County Clerk Passport Acceptance",
      address: "10220 S 76th Ave, Room 238",
      city: "Bridgeview",
      state: "IL",
      zip: "60455",
      phone: "(312) 603-5656",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Bridgeview, approximately 5 miles south of Cicero",
      website: "https://www.cookcountyclerk.com/",
      websiteLabel: "Cook County Clerk",
      notes: "Cook County Clerk satellite passport acceptance. Serves southwest Cook County. Call ahead to confirm hours.",
      icon: "ri-government-line",
    },
    {
      id: "cic-5",
      name: "Forest Park Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "417 Des Plaines Ave",
      city: "Forest Park",
      state: "IL",
      zip: "60130",
      phone: "(708) 366-2049",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Forest Park, approximately 4 miles northwest of Cicero",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Forest Park and near west suburbs. Near CTA Blue Line terminal.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 25 min drive to downtown Chicago", fpc: "No — ship from Cicero" },
    { feature: "Parking & Navigation", agency: "Downtown Chicago parking costs", fpc: "Ship from your neighborhood" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-calendar-close-line",
      title: "Last-Minute Family Travel",
      description: "Cicero families traveling to Mexico and Latin America often discover passport issues days before departure. Holiday travel periods are especially busy — start your passport application at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services around Cermak Road sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background, no shadows or glare.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type cause rejections at Cicero and Berwyn acceptance facilities. First-time applicants especially need to verify which form applies before their appointment.",
    },
    {
      icon: "ri-global-line",
      title: "Dual Citizenship Documentation",
      description: "Many Cicero families hold dual citizenship — U.S. and a Latin American country. When applying for a U.S. passport, ensure you have all required documentation including previous U.S. passport or certified birth certificate.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent for Minors",
      description: "Both parents must appear or submit notarized consent for child passports. Working families in Cicero and Berwyn sometimes arrive with only one parent — causing a rejected application and wasted appointment.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming Standard Processing is Fast Enough",
      description: "Routine passport processing takes 6–13 weeks. If your travel to visit family abroad is within 10 weeks, use expedited service. Summer and December are peak travel seasons.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Cicero or Berwyn area." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx near Cermak Road or Harlem Avenue." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — experienced with family travel, dual-citizenship, and first-time applications." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Chicago Passport Agency — just 25 minutes away but you never make the trip." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Cicero address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Cicero, IL?", a: "Fast Passport Center offers emergency passport processing in Cicero, Illinois in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (25 minutes east via I-290) — without you making the trip." },
    { q: "Does Cicero have its own passport agency?", a: "No — Cicero does not have a regional passport agency. The nearest facility is the Chicago Passport Agency (approximately 25 minutes east via I-290 or Cermak Road). Fast Passport Center's courier service means Cicero residents never need to make the trip." },
    { q: "Can I get an expedited passport in Berwyn or Stickney?", a: "Absolutely. Fast Passport Center serves all of western Cook County including Berwyn, Stickney, Lyons, Oak Park, Forest Park, North Riverside, Brookfield, Riverside, and all near west suburbs. Our service works the same way everywhere." },
    { q: "What airport do Cicero travelers use for international flights?", a: "Chicago Midway International Airport (MDW) is the closest — just 5 minutes east of Cicero. O'Hare (ORD) is approximately 25 minutes north. Both offer extensive international connections. Midway is a Southwest hub with direct flights to Mexico and the Caribbean." },
    { q: "Where can I get passport photos in Cicero?", a: "Walgreens and CVS locations along Cermak Road and Harlem Avenue offer passport photos. UPS Store on Cermak Road also provides them. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Can I get a child's passport expedited in Cicero?", a: "Yes. Fast Passport Center provides child passport services for minors under 16 throughout Cicero and western Cook County. Both parents or legal guardians must typically be present at the acceptance facility." },
    { q: "What if I lost my passport at Midway Airport?", a: "If you lost your passport at Midway Airport, contact Fast Passport Center immediately. We provide emergency lost passport replacement services for Cicero and Chicago-area travelers. Our courier service can get your replacement in 24–48 hours." },
    { q: "Do you help with dual citizenship passport situations?", a: "Yes. Fast Passport Center serves Cicero's diverse international community and is experienced with dual-citizenship documentation. We help ensure your U.S. passport application has all required supporting documents." },
  ],
  photoLocations: [
    { name: "Walgreens — Cicero", address: "4801 W Cermak Rd, Cicero, IL 60804", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/photo/passport-photo", websiteLabel: "Walgreens Photo" },
    { name: "UPS Store — Cicero", address: "5800 W Cermak Rd, Cicero, IL 60804", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/", websiteLabel: "UPS Store" },
    { name: "CVS — Berwyn", address: "6424 Cermak Rd, Berwyn, IL 60402", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/photo/passport-photos", websiteLabel: "CVS Photo" },
    { name: "Walgreens — Berwyn", address: "6831 Cermak Rd, Berwyn, IL 60402", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/photo/passport-photo", websiteLabel: "Walgreens Photo" },
  ],
  dmvLocations: [
    { name: "Illinois SOS — Chicago West", address: "5301 W Lexington St, Chicago, IL 60644", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Illinois Secretary of State for driver's licenses, REAL ID, and vehicle registration. Nearest to Cicero — approximately 5 miles northeast. Online reservations strongly recommended.", featured: true },
    { name: "Illinois SOS — Bridgeview", address: "7365 W 87th St, Bridgeview, IL 60455", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Serves southwest Cook County. Full REAL ID processing available.", featured: false },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (IDPH)", url: "https://dph.illinois.gov/topics-services/birth-death-other-records.html", desc: "Illinois Department of Public Health — Division of Vital Records for Cook County birth and death certificates" },
    { label: "Marriage Licenses (Cook County Clerk)", url: "https://www.cookcountyclerk.com/service/marriage-licenses", desc: "Cook County Clerk — marriage license applications and certified copies for Cicero and western suburbs" },
    { label: "Divorce Decrees (Cook County Circuit Clerk)", url: "https://www.cookcountyclerkofcourt.org/", desc: "Cook County Circuit Clerk — divorce decree records for Cicero and Cook County residents" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Illinois birth, death, marriage, and divorce certificates online via VitalChek — fastest state-approved method" },
  ],
  airports: [
    {
      code: "MDW",
      name: "Chicago Midway International Airport",
      distance: "Approximately 5 minutes east of Cicero",
      address: "5700 S Cicero Ave, Chicago, IL 60638",
      note: "Closest airport to Cicero — located right on Cicero Avenue. Southwest Airlines hub with direct international flights to Mexico, Caribbean, and Central America. Incredibly convenient for Cicero residents.",
      flightUrl: "https://www.flychicago.com/midway/",
      flightLabel: "MDW Flight Info",
      featured: true,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 25 minutes north via I-290 and I-294",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international airport hub. United and American Airlines hub with direct flights to Europe, Asia, and the Americas.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: false,
    },
  ],
};